module.exports = __webpack_public_path__ + "img/setting-printer.4422e23a.png";